<template>
  <ion-page>
    <div class="overlay" >
      <ion-toolbar class='header-bar'>
        <ion-buttons slot="start" @click="openMenu()">
          <div class="pl-05 pointer">
            <ion-icon :icon="appsSharp" />
          </div>
        </ion-buttons>
        <ion-title size="medium">Live Scores</ion-title>
        <ion-buttons slot="end" @click="openSearch()">
          <div class="pr-05 pointer">
            <ion-icon :icon="searchSharp" />
          </div>
        </ion-buttons>
      </ion-toolbar>
    </div>
    <ion-content class="menu-content">
      <div class="welcome mb-2 d-flex flex-column justify-center align-center">
        <img :src="nationalLogo" alt="" srcset="" class="logo">
        <h3 class="c-white">{{ appTitle }}</h3>
      </div>
      <div class="recently-viewed" v-if="recentlyViewed && recentlyViewed.length">
        <div class="d-flex justify-between align-center c-white px-20">
          <h4 class="font-regular">Recently Viewed</h4>
          <!-- <small class="c-gray">View All</small> -->
        </div>
        <ion-grid :scroll-x="true" class="option-row ml-10 d-flex gap-05" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
          <div class="entity" v-for="item in recentlyViewed" :key="item.entity && item.entity._id">
            <entity-card v-if="item.type === 'team'" :entity="item.entity" @click="menuNavigation(`/teams/${item.entity._id}`)" />
            <CompetitionCard v-else-if="item.type === 'competition'" :comp="item.entity" @click="menuNavigation(`/competitions/${item.entity._id}`)" />
          </div>
        </ion-grid>
      </div>
      <div class="state-section">
        <div class="d-flex justify-between align-center c-white px-20">
          <h4 class="font-regular">{{ capitalize(directChild) }}</h4>
        </div>
        <div class="state-list" :key="key">

          <entity-card v-for="state in states" :entity="state" :key="state._id" @click="menuNavigation(`/${directChild}/${state._id}`)" />
        </div>
      </div>

      <div class="state-section">
        <div class="competitions-header d-flex align-center c-white px-20">
          <h4 class="font-regular">Competitions</h4>
          <ion-item lines="none" class="season-filter">
          <ion-label>Season</ion-label>
          <ion-select v-model="filterSeason" interface="popover">
            <ion-select-option v-for="s in seasons" :key="s._id" :value="s._id">{{ s._id }}</ion-select-option>
          </ion-select>
        </ion-item>
        </div>
        <div class="state-list" :key="key">
          <competition-card v-for="comp in filteredCompetitions" :comp="comp" :key="comp._id" @click="menuNavigation(`/competitions/${comp._id}`)" />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  appsSharp,
  closeOutline,
  searchSharp,
} from "ionicons/icons";
import { menuController } from "@ionic/vue";
import EntityCard from '../components/EntityCard.vue'
import CompetitionCard from "../components/CompetitionCard.vue";
import _ from 'lodash';
// import moment from 'moment';
export default {
  components: {
    EntityCard,
    CompetitionCard,
  },
  beforeMount() {
    // const useExplorer = this.$store.getters['national/presentation'].useExplorer;
    // if (!useExplorer) this.$router.push('/tabs/schedule');
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp,
      appsSharp,
      searchSharp
    }
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      states: [],
      competitions: [],
      key: 1,
      directChild: undefined,
      filterSeason: undefined,
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  async mounted() {
    try {
      // Wait for store setup to complete first to ensure seasons are loaded
      await this.$store.dispatch('national/setup');

      const seasons = this.$store.getters['national/seasons'];

      // Load default season from API, fallback to current season
      try {
        const entityType = this.entity?.level || 'national';
        const entityId = this.entity?._id || process.env.VUE_APP_NATIONAL_ID;
        const response = await this.$http.get('/assemble/api/v1/live/presentation-settings', {
          params: { entityType, entityId }
        });
        if (response.data.status === 'success') {
          const defaultSeason = _.get(response.data.data, 'presentationSettings.defaultSeason', null);
          if (defaultSeason) {
            this.filterSeason = defaultSeason;
          }
        }
      } catch (error) {
        console.error('Error loading default season:', error);
      }

      // Fallback logic if no default season set
      if (!this.filterSeason) {
        const currentSeason = _.find(seasons, (season) => _.get(season, 'currentSeason', false) === true);
        const latestSeason = seasons.length > 0 ? seasons[seasons.length - 1] : null;
        if (+process.env.VUE_APP_NATIONAL_ID === 21) {
          this.filterSeason = 2024;
        } else if (currentSeason) {
          this.filterSeason = currentSeason._id;
        } else if (latestSeason) {
          this.filterSeason = latestSeason._id;
        }
      }
      console.log('entity', this.entity);
      if(this.entity && this.entityLevel && this.entityLevel === 'state') {
        this.directChild = this.presentation.stateDirectChild;
      }
      else if(this.entity && this.entity.level === 'association') {
        this.directChild = this.presentation.associationDirectChild;
      }
      else {
        this.directChild = this.presentation.nationalDirectChild;
      }

      console.log({ directChild: this.directChild, entityLevel: this.entityLevel })
      const resstate = await this.$http.get(`/assemble/api/v1/live/${this.directChild}`,{params:{entityType:this.entity.level,entityId:this.entity._id}});
      this.states = resstate.data.data;
      let resComps;
      if(this.entity && this.entity._id){
        resComps = await this.$http.get("/assemble/api/v1/live/competitions",{params:{entityType:this.entity.level,entityId:this.entity._id}});
      }
      else{
        resComps = await this.$http.get("/assemble/api/v1/live/competitions");
      }
      this.competitions = resComps.data.data;
      const sortedCompetition = _.orderBy(this.competitions, ['order'], ['asc']);
      this.competitions = sortedCompetition;
      console.log('competitions', this.competitions);
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  computed: {
    presentation() {
      return this.$store.getters['national/presentation'];
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
    appTitle() {
      const meta = this.$store.getters['national/getMeta'];
      if (meta && meta.name) return meta.name;
      return process.env.VUE_APP_BANNER_TITLE;


    },

    recentlyViewed() {
      return JSON.parse(localStorage.getItem('recentlyViewed')) || [];
    },
    nationalLogo() {
      const meta = this.$store.getters['national/getMeta'];
      console.log('meta',meta);
      if (meta && meta.imgUrl) return meta.imgUrl;
      return process.env.VUE_APP_LOGO;
    },
    seasons(){
      const seasons = this.$store.getters['national/seasons'];
      console.log({
        seasons
      });
      return seasons;
    },
    filteredCompetitions() {
      const sortedCompetition = _.orderBy(_.cloneDeep(this.competitions), ['order'], ['asc']);
      console.log('filteredCompetitions', this.filterSeason, sortedCompetition);
      if(this.filterSeason) {
        return sortedCompetition.filter(comp => comp.season === this.filterSeason);
      }
      return sortedCompetition;
    },
  },
  methods: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    menuNavigation(url){
      menuController.close("side");
      if(this.entity && this.entityLevel && this.entityName){
        url = `/c/${this.entityLevel}/${this.entityName}${url}`
      }
      this.$router.push(url);
    },
    goPrev() {
      this.$router.go(-1);
    },
    openMenu() {
      // menuController.enable(true, 'side');
      menuController.open('side');
    },
    openSearch() {
      this.$router.push('/search');
    }
  }
};
</script>
<style scoped lang="scss">

// .option-row {
//   display: flex;
//   gap: 1rem;
//   position: relative;
// }
.logo {
  max-width: clamp(5rem, 20vw, 15rem);
  background: $background;
}

ion-input {
  --background: #191a1d !important;
}

h5 {
  margin-top: 0;
}

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  --background: #191a1d;
  --color: #fff;
  --placeholder-color: #fff;
  --icon-color: #fff;
  --clear-button-color: #fff;
  --border-radius: 1rem;
  color: #fff;
  margin: 1rem 2rem;
  max-width: 85%;
  background: #191a1d !important;
  border: 1px solid #616161;
  border-radius: 1rem;
  input {
    --background: #191a1d;
    background: #191a1d;
  }
}


.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.state-list {
  margin: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(15rem, 20rem));
  }
  gap: 0.5rem;
  .state-option {
    &:hover {
      cursor: pointer;
      background: var(--highlight-color) !important;
     }
    display: grid;

    // flex-direction: column;
    // justify-content: center;
    align-items: center;
    gap: 1rem;
    background: #17181B;
    border-radius: 1rem;
    padding: 1rem 1rem;
  }
}
.competition-list {
  margin: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(15rem, 20rem));
  }
  gap: 0.5rem;
  .competition-option {
    &:hover {
      cursor: pointer;
      background: var(--highlight-color) !important;
     }
    display: grid;

    // flex-direction: column;
    // justify-content: center;
    align-items: center;
    gap: 1rem;
    background: #17181B;
    border-radius: 1rem;
    padding: 1rem 1rem;
  }
}

@media only screen and (min-width: 768px) {
  .competition-option {
    min-width: 15rem;
    &:hover {
      cursor: pointer;
      background: var(--highlight-color) !important;
     }
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  // padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.state-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.season-filter {
  --background: transparent;
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  flex-shrink: 0;

  ion-label {
    margin-right: 8px;
    white-space: nowrap;
  }

  ion-select {
    min-width: 70px;
    --padding-start: 0;
    --padding-end: 0;
  }
}

@media only screen and (max-width: 480px) {
  .season-filter {
    ion-label {
      display: none;
    }
  }
}

.competitions-header {
  flex-wrap: nowrap;
  gap: 0.5rem;
  justify-content: space-between;

  h4 {
    flex-shrink: 0;
    margin: 0;
  }
}

</style>
